import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Formsy from "formsy-react";
import { Input } from "formsy-react-components";
import { Row, Col, Image } from "react-bootstrap";
import { IoPerson, IoKey } from "react-icons/io5";

import Logo from "../../assets/logos/Iris-Logo-Web_White.png";
import { sanitizeText } from "../../helpers/index";

const LoginForm = ({ onSave, saving }) => {
  const [canSubmit, setCanSubmit] = useState(false);

  const enableButton = () => setCanSubmit(true);

  const disableButton = () => setCanSubmit(false);

  const submit = (model) => {
    onSave(sanitizeText(model));
  };

  return (
    <Formsy
      className="login form"
      onValidSubmit={submit}
      onValid={enableButton}
      onInvalid={disableButton}
    >
      <Image
        responsive
        src={Logo}
        alt="iris-logo"
        width={200}
        style={{ marginBottom: 60 }}
      />
      <Input
        required
        type="text"
        name="email"
        placeholder="Email or username"
        addonBefore={<IoPerson />}
      />
      <Input
        required
        type="password"
        name="password"
        placeholder="Password"
        addonBefore={<IoKey />}
      />
      <Row className="text-center">
        <input
          className="btn btn-success"
          type="submit"
          disabled={!canSubmit}
          value={saving ? "Signing In... " : "Sign In"}
        />
      </Row>
      <Row>
        <Col md={12} style={{ textAlign: "center", marginTop: "10px" }}>
          <Link to="/forgot">Forgot Password?</Link>
        </Col>
      </Row>
    </Formsy>
  );
};

LoginForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default LoginForm;
